import React from "react"
import {DateField} from "ra-ui-materialui"
import {timeOptions, dateOptions} from "lib/consts"

export default ({ options, showTime = true, ...props}) => {
  const opts = showTime ? { ...timeOptions, ...options } : dateOptions
  return <DateField options={opts} {...props} />
}
